import React from 'react';
import PropTypes from 'prop-types';

import InputAdornment from '@mui/material/InputAdornment';

import WaeStandardTextField from '../../../components/WaeStandardTextField/WaeStandardTextField';
import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import { PAY_RATE_INPUT_PATTERN } from '../constants';

import { textFieldSx } from './formFieldStyles';

const currencyFieldSx = {
  ...textFieldSx,
  '& .MuiInputBase-input': {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '14px',
    fontVariantNumeric: 'tabular-nums',
  },
  '& .MuiOutlinedInput-input': {
    padding: '10px 12px 10px 0',
  },
};

const formatRate = (value) => {
  if (!value) return '';
  const parsed = Number.parseFloat(value);
  return Number.isNaN(parsed) ? '' : parsed.toFixed(2);
};

const CurrencyField = ({ id, value, onChange, testId }) => {
  const handleChange = (event) => {
    const nextValue = event.target.value;
    if (PAY_RATE_INPUT_PATTERN.test(nextValue)) {
      onChange(nextValue);
    }
  };

  const handleBlur = () => {
    const formatted = formatRate(value);
    if (formatted !== value) {
      onChange(formatted);
    }
  };

  return (
    <WaeStandardTextField
      id={id}
      fullWidth
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      InputProps={{
        inputProps: { inputMode: 'decimal', 'data-testid': testId },
        startAdornment: (
          <InputAdornment position="start" sx={{ color: BLACK[70], marginRight: '4px' }}>
            $
          </InputAdornment>
        ),
      }}
      sx={currencyFieldSx}
    />
  );
};

CurrencyField.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testId: PropTypes.string,
};

export default CurrencyField;
